/**
 * Created by dv on 7/12/2017.
 */
import {
    LiveDrawSpecMessage,
    LiveDrawSpecResponse,
    LiveDrawSpecQuery
  } from "../autogenerated/ZoomBridge";
  /**
   * Add assets to a existing collection
   */
  export default class GetLiveDrawSpec {
    constructor() {
    }
  
    /**
     * Returns a {Promise} Instance with onSuccess and OnFailure method.
     * onSuccess method takes resp{SimpleResponse} type.
     * @return {Promise}
     * 
     * @public
     */
    run() {
      const query = new LiveDrawSpecQuery();
      const msg = new LiveDrawSpecMessage();
      query.message = msg;
      return query.run();
    }
  }
  